import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const STICKS_ROUTES: Routes = [
  {
    path: 'sticks-tv/list',
    loadComponent: () => import('../features/sticks-tv/list/list.component').then(m => m.SticksTvListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'sticks-tv/edit/:id',
    loadComponent: () => import('../features/sticks-tv/edit/edit.component').then(m => m.StickTvEditComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'sticks-tv/wifi-connection',
    loadComponent: () =>
      import('../features/sticks-tv/wifi-connection/list/list.component').then(m => m.WifiConnectionListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD, ROLES.TECH],
    },
  },
  {
    path: 'sticks-tv-admin/list',
    loadComponent: () =>
      import('../features/sticks-tv-admin/list/list.component').then(m => m.SticksTvAdminListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'sticks/stock',
    redirectTo: 'terminaux-ogeste/stock',
    pathMatch: 'full',
  },
  {
    path: 'terminaux-ogeste/stock',
    loadComponent: () => import('../features/sticks-stock/stock.component').then(m => m.SticksStockComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD, ROLES.TECH],
    },
  },
  {
    path: 'atelier-inventaire',
    loadComponent: () =>
      import('../features/hardware-atelier/hardware-atelier.component').then(
        (m) => m.HardwareAtelierComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.EHPAD, ROLES.TECH],
    },
  },
  {
    path: 'router-ogeste/list',
    redirectTo: 'sticks-tv-admin/list',
    pathMatch: 'full',
  },
];
